import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { ContentBlockComponent } from "../../component/content-block/content-block.component";
import { ImageSliderComponent } from "../../component/image-slider/image-slider.component";
import { NgForOf, NgIf } from "@angular/common";
import { HttpClient } from "@angular/common/http";
import { ConfigService } from "../../common/service/config.service";
import { mergeMap, Subscription, tap } from "rxjs";
import { CommonComponent } from "../../common/common-component";
import { RouterLink } from "@angular/router";
import { environment } from "../../../environments/environment";
import { FaIconComponent } from "@fortawesome/angular-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";

@Component({
  selector: 'section#themes.w-100',
  standalone: true,
  imports: [
    ContentBlockComponent,
    ImageSliderComponent,
    NgForOf,
    NgIf,
    RouterLink,
    FaIconComponent
  ],
  templateUrl: './generation-selection.component.html'
})
export class GenerationSelectionComponent extends CommonComponent implements OnInit, OnDestroy{

  protected readonly faCheck = faCheck;

  public themes: Array<any> = [];
  formInvalid: boolean = true;
  public boothMode: boolean = false;

  private subscription: Subscription | undefined;

  constructor(
    private httpClient: HttpClient,
    private configService: ConfigService,
    @Inject('Storage') protected storage: Storage
  ) { super(); }

  ngOnInit(): void {

    const userConfig = JSON.parse(this.storage.getItem('user_config') || '{}');
    let selection = [...new Set(userConfig['<!--(generations)--!>'] || [])];

    this.subscription =  this.configService.config$.pipe(
      tap(config => this.config = config),
      mergeMap(() => this.httpClient.get<Array<{id: string, sampleUrl: string, preselected: boolean, label: string}>>(environment.api_v2_url + '/event/' +this.config.id +'/themes')),
    ).subscribe((items: Array<any>) => {
      // this.themes = items;
      this.themes = items;
      selection = selection.filter((x: any) => this.themes.map((t: any) => t.id).includes(x));

      for(let t of this.themes) {
        if(t.preselected) {
          t.selected = true;
          selection.push(t.id);
        }
        else {
          t.selected = selection.includes(t.id);
        }
      }

      userConfig['<!--(generations)--!>'] = [...new Set(selection)]
      this.storage.setItem('user_config', JSON.stringify(userConfig));
      this.formInvalid = userConfig['<!--(generations)--!>'].length === 0;
    });
  }

  ngOnDestroy(): void {
    if(this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  isSelected(theme: any) {
    if(theme.preselected) {
      return true;
    } else {
      return theme.selected || false;
    }
  }

  toggleSelection(theme: any) {
    if (theme.preselected) {
      return;
    } else {
      // console.log('ok');

      const userConfig = JSON.parse(this.storage.getItem('user_config') || '{}');
      const selection = [...new Set(userConfig['<!--(generations)--!>'] || [])];

      // console.log('selection', selection, selection.length, this.config.generationSelectionLimit);
      // console.log('theme', theme, ! theme.selected);

      if( ! theme.selected && this.config.generationSelectionLimit && this.config.generationSelectionLimit > 0 && selection.length >= this.config.generationSelectionLimit) {

        if(this.config.generationSelectionLimit === 1) {
          for(let t of this.themes) {
            t.selected = false;
          }
          theme.selected = true;
          userConfig['<!--(generations)--!>'] = [theme.id];
          this.storage.setItem('user_config', JSON.stringify(userConfig));
          this.formInvalid = userConfig['<!--(generations)--!>'].length === 0;
        }
        return;
      }

      theme.selected = ! (theme.selected || false);

      // console.log('user1', userConfig)

      // console.log('selection', selection);

      if(theme.selected) {
        if ( ! selection.includes(theme.id)) {
          selection.push(theme.id);
          userConfig['<!--(generations)--!>'] = selection;
        }
      } else {
        if (selection.includes(theme.id)) {
          userConfig['<!--(generations)--!>'] = selection.filter((x: any) => x !== theme.id);
        }
      }

      // console.log('user2', userConfig);
      this.storage.setItem('user_config', JSON.stringify(userConfig));
      this.formInvalid = userConfig['<!--(generations)--!>'].length === 0;
    }
  }

  countSelected(themes: Array<any>) {
    return themes.filter((t: any) => t.selected).length;
  }

  getSampleImageUrl(theme: any): string {

    const userConfig = JSON.parse(this.storage.getItem('user_config') || '{}');
    const gender = userConfig['<!--(gender)--!>'];

    if(gender) {
      if(gender == 'man' && theme.mSampleUrl && theme.mSampleUrl !== '') {
        return theme.mSampleUrl;
      }
      else if(gender == 'woman' && theme.fSampleUrl && theme.fSampleUrl !== '') {
        return theme.fSampleUrl;
      }
    }

    return theme.sampleUrl;
  }
}

